module.exports = __webpack_public_path__ + "static/media/manager.9263ad5d.svg";